<template>
  <div id="fh5co-wrapper">
    <div id="fh5co-page">
      <Header></Header>
      <div>
        <div style="background-image: url(/static/home-image-2.jpg);" data-stellar-background-ratio="0.5">
          <div class="text-center youtube">
            <iframe width="560" height="315" class="training-video" src="https://www.youtube.com/embed/f_0tikr2vdI" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
          </div>
        </div><!-- end: fh5co-parallax -->
        <div class="row">
          <div class="col-md-8 col-md-offset-2">
            <div class="heading-section text-center">
              <h1 class="heading02 text-center mt-2"><span class="underline1">TRXサスペンションでのトレーニング</span></h1>
              <p>TRXサスペンションを使えば自宅でも簡単に本格的なトレーニングを行うことができます！</p>
            </div>
          </div>
        </div>
        <div class="row text-center feature1-image-container">
          <div class="col-md-2 col-sm-6 col-md-offset-1">
            <div>
              <img src="/static/trx01.jpg" alt="TRXチェストプレス シングルレッグ">
              <h3>TRXチェストプレス シングルレッグ</h3>
            </div>
          </div>
          <div class="col-md-2 col-sm-6">
            <div class="animate-box">
              <img src="/static/trx02.jpg" alt="TRXインバーテッドロウ">
              <h3>TRXインバーテッドロウ</h3>
            </div>
          </div>
          <div class="col-md-2 col-sm-6">
            <div class="animate-box">
              <img src="/static/trx03.jpg" alt="TRXフォワードランジ">
              <h3>TRXフォワードランジ</h3>
            </div>
          </div>
          <div class="col-md-2 col-sm-6">
            <div class="animate-box">
              <img src="/static/trx04.jpg" alt="TRXプッシュアップ">
              <h3>TRXプッシュアップ</h3>
            </div>
          </div>
          <div class="col-md-2 col-sm-6">
            <div class="animate-box">
              <img src="/static/trx05.jpg" alt="TRXローテーション">
              <h3>TRXローテーション</h3>
            </div>
          </div>
        </div>
        <div class="row text-center feature1-image-container">
          <div class="col-md-2 col-sm-6 col-md-offset-1">
            <div>
              <img src="/static/trx06.jpg" alt="TRXチェストプレス">
              <h3>TRXチェストプレス</h3>
            </div>
          </div>
          <div class="col-md-2 col-sm-6">
            <div class="animate-box">
              <img src="/static/trx07.jpg" alt="TRXワイフライ">
              <h3>TRXワイフライ</h3>
            </div>
          </div>
          <div class="col-md-2 col-sm-6">
            <div class="animate-box">
              <img src="/static/trx08.jpg" alt="TRXフロントスクワット">
              <h3>TRXフロントスクワット</h3>
            </div>
          </div>
          <div class="col-md-2 col-sm-6">
            <div class="animate-box">
              <img src="/static/trx09.jpg" alt="TRXオブリーククランチ">
              <h3>TRXオブリーククランチ</h3>
            </div>
          </div>
          <div class="col-md-2 col-sm-6">
            <div class="animate-box">
              <img src="/static/trx10.jpg" alt="TRXローロウ">
              <h3>TRXローロウ</h3>
            </div>
          </div>
        </div>
        <div class="fh5co-parallax mt-2 parallax-container-02">
          <div class="container">
            <div class="row">
              <div class="col-md-6 col-md-offset-3 col-md-pull-3 col-sm-12 col-sm-offset-0 col-xs-12 col-xs-offset-0 fh5co-table">
                <div class="fh5co-intro fh5co-table-cell box-area">
                  <div class="animate-box">
                    <h1>TRX<br>Training</h1>
                    <!-- <a href="https://coubic.com/legame/products#pageContent" title="480円～ 入会申込" target="_blank" rel="noopener noreferrer" class="btn btn-blue text-bold">480円～ 入会申込</a> -->
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="pos-rel mt-2">
          <div class="container">
            <div class="row">
              <div class="col-md-6">
                <h1 class="heading-solid1 text-center mt-2">TRXの魅力１</h1>
                <h2 class="heading02 mt-2"><span class="underline1">小スペースで効率よく全身を鍛えられる。</span></h2>
                <p class="mt-2">
                  場所を取らずに本格的なトレーニングを行うことができます！
                  使わない時は簡単に片付けられるのも魅力です。
                </p>
              </div>
              <div class="col-md-6">
                <div class="row text-center feature1-image-container mt-2">
                  <div class="col-md-6 col-sm-6">
                    <img src="/static/trx_space01.jpg" alt="スペースを取らずに本格的なトレーニング">
                  </div>
                  <div class="col-md-6 col-sm-6">
                    <img src="/static/trx_space03.jpg" alt="使わない時は簡単に片付けられる">
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="mt-2">
          <div class="container">
            <div class="row">
              <div class="col-md-6 col-md-push-6 col">
                <h1 class="heading-solid1 text-center mt-2">TRXの魅力２</h1>
                <h2 class="heading02 mt-2"><span class="underline1">高齢者の筋力向上や障害後のリハビリにも最適！</span></h2>
                <p class="mt-2">
                  トレーニングの負荷を自在に調整できるので、高齢の方の運動不足解消・筋力向上やケガをされた方のリハビリにも安心してお使いいただけます。
                </p>
              </div>
              <div class="col-md-6 col-md-pull-6 col">
                <div class="row text-center feature1-image-container mt-2">
                  <div class="col-md-6 col-sm-6">
                    <img src="/static/trx_space05.jpg" alt="高齢者の筋力向上に最適！">
                  </div>
                  <div class="col-md-6 col-sm-6">
                    <img src="/static/trx_space06.jpg" alt="高齢者の運動不足解消にも最適！">
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="heading-section text-center animate-box mt-2">
        <span><a class="btn btn-border btn-large btn-trx" href="https://trxtraining.jp/products/" target="_blank" rel="noopener noreferrer">TRXサスペンションの<br class="visible-xs">購入はこちら</a></span>
      </div>
      <!-- <div class="heading-section text-center animate-box mt-2">
        <span><a class="btn btn-border btn-blue btn-large" href="https://coubic.com/legame/products#pageContent" title="入会申し込み" target="_blank" rel="noopener noreferrer">入会申し込み</a></span>
      </div> -->
      <Footer></Footer>
    </div>
  </div>
</template>

<script>
import Header from './Header.vue'
import Footer from './Footer.vue'

export default {
  name: 'Trx',
  components: {
    Header,
    Footer
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.feature1-image-container>div{
  margin-bottom: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/Trx.vue